import { ReactNode, useState } from 'react'

import { routes } from '@builddocs/data-management'
import { Notification } from '@builddocs/mui'
import { PaywallContext } from '@builddocs/system'
import { Modal, Typography } from 'antd'

interface PaywallProviderProps {
  children: ReactNode
}

export function PaywallProvider({ children }: PaywallProviderProps) {
  const [message, setMessage] = useState<React.ReactNode | null>(null)
  const [title, setTitle] = useState<string | null>(null)

  const handleOpen = (operationInfo?: {
    isAllowed: boolean
    requestedLimit: number
    availableLimit: number
    isReadOnly?: boolean
    denyReasonCode?: string
  }) => {
    if (
      operationInfo?.isReadOnly ||
      operationInfo?.denyReasonCode === 'READ_ONLY_PROJECT'
    ) {
      const message = (
        <span>
          Действие недоступно на вашем тарифе. Приобретите тариф{' '}
          <Typography.Link href={`${routes.tariffs.root()}?list`}>
            Про
          </Typography.Link>
          , чтобы открыть доступ
        </span>
      )

      setMessage(message)
      setTitle('Действие недоступно в Базовом тарифе')
      return
    }

    if (
      typeof operationInfo?.isAllowed === 'boolean' &&
      !operationInfo?.isAllowed
    ) {
      const message =
        operationInfo?.availableLimit === 0 ? (
          <span>
            Достигнут лимит данной операции для текущего тарифа. Чтобы получить
            больше возможностей, выберите подходящий тариф{' '}
            <Typography.Link href={`${routes.tariffs.root()}?list`}>
              здесь
            </Typography.Link>
            .
          </span>
        ) : (
          <span>
            Для текущего тарифа превышен лимит данной операции: запрошено —{' '}
            {operationInfo?.requestedLimit}, доступно —{' '}
            {operationInfo?.availableLimit}. Посмотреть тарифы и оформить
            подписку можно{' '}
            <Typography.Link href={`${routes.tariffs.root()}?list`}>
              здесь
            </Typography.Link>
            .
          </span>
        )

      setMessage(message)
      setTitle('Лимит исчерпан')
    }
  }

  const handleClose = () => {
    setMessage(null)
  }

  return (
    <PaywallContext.Provider
      value={{
        open: handleOpen,
        close: handleClose,
      }}
    >
      {children}
      <Modal
        centered
        footer={() => false}
        open={!!message}
        title={title}
        onCancel={handleClose}
      >
        <Notification
          message={message}
          sx={{
            borderRadius: '8px',
          }}
        />
      </Modal>
    </PaywallContext.Provider>
  )
}
